export default {
  oneTime: {
    en: 'One-time purchase',
  },
  label: {
    en: 'Gift Subscription',
  },
  months: {
    en: '{months, plural, one {# month} other {# months}}',
  },
}
